import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { CheckCircle2Icon, XIcon } from "lucide-react";
import { buyers, MOCKUP_URL } from "../data/offer";
type Purchase = {
  name: string;
  country: string;
  minutes: number;
};
export function PurchasePopup() {
  const [purchase, setPurchase] = useState<Purchase | null>(null);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    let index = Math.floor(Math.random() * buyers.length);
    let showTimer: number;
    let hideTimer: number;
    const schedule = (delay: number) => {
      showTimer = window.setTimeout(() => {
        const buyer = buyers[index % buyers.length];
        index += 1;
        setPurchase({
          ...buyer,
          minutes: 1 + Math.floor(Math.random() * 14)
        });
        setOpen(true);
        hideTimer = window.setTimeout(() => {
          setOpen(false);
          schedule(9000);
        }, 5000);
      }, delay);
    };
    schedule(6000);
    return () => {
      window.clearTimeout(showTimer);
      window.clearTimeout(hideTimer);
    };
  }, []);
  return <div className="pointer-events-none fixed bottom-24 left-3 right-3 z-50 sm:left-5 sm:right-auto" aria-live="polite" data-id="element-43" data-mp="1175ws4jxn4gw">
      <AnimatePresence data-id="element-44" data-mp="1fur1g2wghbqx">
        {open && purchase && <motion.div initial={{
        opacity: 0,
        y: 16,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 16,
        scale: 0.96
      }} transition={{
        duration: 0.22,
        ease: [0.23, 1, 0.32, 1]
      }} className="pointer-events-auto relative flex w-full items-center gap-3 rounded-2xl border border-line bg-white p-3 pr-9 shadow-[0_12px_32px_rgba(14,37,87,0.22)] sm:w-[22rem]" data-id="element-45" data-mp="1fxn3a2bfckkn">
            <img src={MOCKUP_URL} alt="" className="h-14 w-14 shrink-0 rounded-xl bg-brand-soft object-contain p-1" data-id="element-46" data-mp="s5exbhfzjtvh" />
            <div className="min-w-0" data-id="element-47" data-mp="28imxd5e7azmn">
              <p className="text-sm font-black leading-snug text-navy" data-id="element-48" data-mp="23lmzhhri936m">
                {purchase.name} from {purchase.country}
              </p>
              <p className="text-[13px] font-semibold leading-snug text-ink/75" data-id="element-49" data-mp="2ao1mowszbnp8">
                just purchased the Complete Blueprint™
              </p>
              <p className="mt-0.5 flex items-center gap-1 text-xs font-bold text-leaf" data-id="element-50" data-mp="2kn0obvfbuj2q">
                <CheckCircle2Icon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-51" data-mp="2plu4jvm00o6l" />
                Verified purchase · {purchase.minutes} min ago
              </p>
            </div>
            <button type="button" onClick={() => setOpen(false)} className="absolute right-2 top-2 rounded-full p-1 text-ink/50 transition-colors duration-150 hover:bg-line hover:text-navy" aria-label="Close notification" data-id="element-52" data-mp="1rvz4hh0ovzcv">
              <XIcon className="h-4 w-4" data-id="element-53" data-mp="26oassk85orgh" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}